import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#trainee_info",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Cirtification Status")
  ])
], -1)
const _hoisted_3 = {
  id: "trainee_info",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institutes", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-md-3 mt-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_19 = { class: "col-md-3 mt-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "col-md-2 mt-5" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Trainee Cirtification Status", -1)
const _hoisted_28 = { class: "card mb-5 mb-xl-10" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, null, -1)
const _hoisted_30 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_31 = { class: "collapse show" }
const _hoisted_32 = { class: "card-body border-top p-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "row w-100 m-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
  ])
], -1)
const _hoisted_34 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_35 = ["href"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", {
  title: "Income Certificate",
  class: "fa fa-file",
  "data-original-title": "Found",
  style: {"color":"cornflowerblue","font-size":"20px"}
}, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 1,
  href: "javascript:void(0);"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", {
  title: "File Not Uploaded",
  class: "fa fa-times",
  "data-original-title": "Not Found",
  style: {"color":"red","font-size":"20px"}
}, null, -1)
const _hoisted_40 = [
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  placeholder: "Select Tranche",
                  modelValue: _ctx.trainee.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.tranche_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trancheChange()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Tranche"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Tranche")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: trans.id,
                        label: trans.label,
                        value: trans.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(trans.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createVNode(_component_el_select, {
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  class: "form-select-solid",
                  placeholder: "Select Training Partner",
                  modelValue: _ctx.trainee.entity_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trainee.entity_id) = $event)),
                  style: {"width":"100%"},
                  filterable: "",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trainingInstitute()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Training Partner"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Training Partner")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: assoc.id,
                        label: assoc.entity_short_name,
                        value: assoc.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("[" + _toDisplayString(assoc.entity_short_name) + "]-" + _toDisplayString(assoc.entity_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Institute",
                  modelValue: _ctx.trainee.training_institute_id,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.trainee.training_institute_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getCourseList()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Institute"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Institute")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: inst.id,
                        label: inst.institute_name,
                        value: inst.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(inst.institute_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "collapse-tags": "",
                  placeholder: "Select Course",
                  modelValue: _ctx.trainee.course_info_id,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trainee.course_info_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getBatchList()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Course"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Course")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: course.id,
                        label: course.course_name,
                        value: course.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(course.course_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _hoisted_21,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "collapse-tags": "",
                  placeholder: "Select Batch",
                  modelValue: _ctx.trainee.batch_info_id,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.trainee.batch_info_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Batch"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Batch")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batches, (batch) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: batch.id,
                        label: batch.batch_sequence_number,
                        value: batch.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(batch.batch_sequence_number), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.generateIncomeCertificateReport())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_23
                ])
              ])
            ]),
            (_ctx.showtraineeInfo == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
              : _createCommentVNode("", true),
            (_ctx.showTableData == true)
              ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_Datatable, {
                              "table-data": _ctx.tableData,
                              "table-header": _ctx.tableHeader,
                              "enable-items-per-page-dropdown": true
                            }, {
                              "cell-sl": _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.id), 1)
                              ]),
                              "cell-ref_no": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.reference_number), 1)
                              ]),
                              "cell-reg_no": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.registration_number), 1)
                              ]),
                              "cell-trainee_name": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.trainee_name), 1)
                              ]),
                              "cell-mobile": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.mobile), 1)
                              ]),
                              "cell-gender": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.gender), 1)
                              ]),
                              "cell-file": _withCtx(({ row: industry }) => [
                                (industry.income_certificate)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      target: "_blank",
                                      href: `${_ctx.VUE_APP_API_URL}/${industry.income_certificate.file_name}`
                                    }, _hoisted_37, 8, _hoisted_35))
                                  : (_openBlock(), _createElementBlock("a", _hoisted_38, _hoisted_40))
                              ]),
                              "cell-last_update": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.updated_at
                                ? _ctx.moment(industry?.updated_at).format(
                                    'DD-MM-YYYY'
                                  )
                                : industry?.updated_at), 1)
                              ]),
                              _: 1
                            }, 8, ["table-data", "table-header"])
                          ])
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}